'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import debounce from 'react-utils/debounce';
import { compose } from 'underscore';
import ReactCodeMirror from 'react-codemirror';
import softTabs from 'react-codemirror/decorator/softTabs';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import { getJsonString, EMPTY_JSON_BLOCK } from '../../utils/jsonUtils';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
const CodeMirrorWithAddons = compose(softTabs())(ReactCodeMirror);
export default class JSONInput extends Component {
  constructor(props) {
    super(props);

    this.updateValue = jsonStr => {
      let value;

      if (!jsonStr) {
        // It's ok if they clear the editor, but we don't want to try to
        // JSON.parse an empty string because it'll error.
        this.setState({
          validValue: {},
          invalidJson: false
        });
        this.props.onChange({});
      } else {
        try {
          value = JSON.parse(jsonStr);
          this.setState({
            validValue: value,
            invalidJson: false
          });
          this.props.onChange({
            properties: value
          });
        } catch (e) {
          this.setState({
            invalidJson: true
          });
        }
      }
    };

    this.onChange = ({
      value
    }) => {
      this.setState({
        json: value
      });
      this.debouncedUpdate(value);
    };

    this.refCodemirror = ref => {
      this.codemirror = ref && ref.codemirror;
    };

    this.state = {
      json: getJsonString(props.value, true),
      validValue: props.value
    };
    this.debouncedUpdate = debounce(this.updateValue, 500);
  }

  componentDidMount() {
    const {
      autoFocus
    } = this.props;
    this.codemirror.refresh();

    if (autoFocus) {
      this.codemirror.focus();

      if (this.state.json === EMPTY_JSON_BLOCK) {
        this.codemirror.doc.setCursor({
          line: 1
        });
      }
    }
  }

  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(CodeMirrorWithAddons, {
        autoCloseBrackets: true,
        lineWrapping: true,
        matchBrackets: true,
        mode: "application/json",
        onChange: this.onChange,
        readOnly: false,
        refCodemirror: this.refCodemirror,
        style: {
          maxHeight: 300
        },
        theme: "hubspot-canvas-dark",
        width: "100%",
        value: this.state.json
      }), this.state.invalidJson && /*#__PURE__*/_jsx(Small, {
        use: "error",
        "data-test-id": "invalid-json-error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.errors.invalidJson"
        })
      })]
    });
  }

}
JSONInput.propType = {
  autoFocus: PropTypes.string,
  value: PropTypes.string
};